const useCases = [
  {
    icon: 'ri-heart-line',
    title: 'Weddings & Private Events',
    description:
      'Custom configurations tailored to your venue and theme. Create the perfect intimate atmosphere or grand celebration space with bespoke sizing, custom colours, and unique shapes for any venue.',
    image:
      '/assets/img/weddings-08.webp',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Restaurants & Hospitality',
    description:
      'Turn outdoor areas into year-round revenue-generating spaces. Weather-proof dining that keeps guests comfortable in any season — fully waterproof, UV resistant, and built for all-weather use.',
    image:
      '/assets/img/1ccd4f0e7d48.webp',
  },
  {
    icon: 'ri-flag-line',
    title: 'Brand Activations & Festivals',
    description:
      'Crowd-drawing cover for markets, fan zones, and activations. Make your brand unmissable with a bold custom printed skin featuring full-colour dye-sublimation graphics and high-res branding.',
    image:
      '/assets/img/brand-activations-05.webp',
  },
];

export default function UseCaseCards() {
  return (
    <section className="py-20 bg-teal-500">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-white mb-3">
            A Solution for Every Occasion
          </h2>
          <p className="text-teal-100 text-base max-w-xl mx-auto">
            From intimate gatherings to large-scale commercial installations, we engineer the perfect cover.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {useCases.map((item, index) => (
            <div
              key={index}
              className="group bg-white/15 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/25 hover:-translate-y-1 transition-transform duration-300 cursor-default"
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-7">
                <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-white mb-3 leading-snug">
                  {item.title}
                </h3>
                <p className="text-teal-100 text-sm leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
